import { memo } from 'react';
import { MenuTrigger } from 'react-aria-components';

import { merge } from '@/components';
import { Button, Menu, MenuItemDelete, Popover } from '@/components/core';
import { OverflowIcon } from '@/components/icons';
import { DivProps, OmitChildren } from '@/utils';

export type FilterCardProps = DivProps & {
  onDelete: () => void;
};

const IFilterCard = ({ onDelete, className, children, ...rest }: FilterCardProps) => {
  return (
    <div
      className={merge(
        'group/filter-card border-primary-200 bg-primary-50 px-xs flex items-center rounded-full border',
        className
      )}
      {...rest}
    >
      {children}
      <MenuTrigger>
        <Button variant="plain">
          <OverflowIcon />
        </Button>
        <Popover>
          <Menu>
            <MenuItemDelete onAction={onDelete} />
          </Menu>
        </Popover>
      </MenuTrigger>
    </div>
  );
};

export const FilterCard = memo(IFilterCard) as typeof IFilterCard;
export type FilterCardSubType = Omit<OmitChildren<FilterCardProps>, 'onDelete'>;
